export enum ANALYTICS_ACTIONS {
  VIEW = 1,
  GOOGLE_MAPS_CLICKED = 2,
  CLICKED_GENERATE_REVIEW = 3,
}
